<template>
  <section class="package-contract-terms" aria-label="Vertragsbedingungen">
    <div class="package-contract-terms__item">
      <span class="package-contract-terms__icon" aria-hidden="true">
        <Icon icon="fa-pro-solid:calendar-days" />
      </span>
      <div>
        <span class="package-contract-terms__label">Vertragslaufzeit</span>
        <strong>1 Monat</strong>
      </div>
    </div>

    <div class="package-contract-terms__item">
      <span class="package-contract-terms__icon" aria-hidden="true">
        <Icon icon="fa-pro-solid:circle-check" />
      </span>
      <div>
        <span class="package-contract-terms__label">Kündigungsfrist</span>
        <strong>Jederzeit kündbar</strong>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PackageContractTerms',
}
</script>

<style scoped lang="scss">
.package-contract-terms {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.7rem;
  margin-top: 1rem;
}

.package-contract-terms__item {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  padding: 0.75rem 0.8rem;
  border: 1px solid #d9e3ec;
  background: #f7fafc;
}

.package-contract-terms__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 1.1rem;
  margin-top: 0.15rem;
  color: #1f6f8b;
}

.package-contract-terms__label {
  display: block;
  margin-bottom: 0.15rem;
  color: #5d7183;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.package-contract-terms strong {
  display: block;
  color: #10273d;
  font-size: 0.96rem;
  line-height: 1.25;
}

@media (max-width: 575px) {
  .package-contract-terms {
    grid-template-columns: 1fr;
  }
}
</style>
